import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Tooltip,
  IconButton,
  InputBase,
  Typography,
  Button,
  Dialog,
  TextField,
  DialogContentText,
  DialogContent,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseSupplier } from "./UseSupplier";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useSnackbar } from "notistack";

export default function Supplier() {
  const { enqueueSnackbar } = useSnackbar();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { getSupplierList, deleteSupplier, updateVisitor } = UseSupplier();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("CompanyName");
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const [supplierRes, setSupplierRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [checkState, setCheckState] = useState({
    show: false,
    mobile: undefined,
  });
  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getSupplierList(
      myPc,
      search,
      (suppliers) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(suppliers.pageCondition.totalPage);
          return;
        }
        setSupplierRes(suppliers);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/suppliers/addSupplier", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "companyName",
      headerName: "نام شرکت",
      width: 170,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.companyName}
          </Typography>
        );
      },
    },
    {
      field: "visitor",
      headerName: "نام ویزیتور",
      width: 170,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.visitor ? cellValues.row.visitor : "-"}
          </Typography>
        );
      },
    },
    {
      field: "visitorMobile",
      headerName: "شماره ویزیتور",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.visitorMobile ? cellValues.row.visitorMobile : "-"}
          </Typography>
        );
      },
    },
    {
      field: "companyMobile",
      headerName: "شماره شرکت",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.companyMobile ? cellValues.row.companyMobile : "-"}
          </Typography>
        );
      },
    },

    {
      field: "isEnable",
      headerName: "فعال",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.isEnable ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 100,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Delete">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.companyName,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());

                  return navigate("/suppliers/editSupplier", {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
    {
      field: "updatevisitor",
      width: 130,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Button
            onClick={() => setCheckState({ show: true, mobile: undefined })}
            color="secondary"
            variant="contained"
          >
            شناسایی ویزیتور
          </Button>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "بازرگانی",
        childs: [{ name: msActiveMenu.pageTitle, url: "/suppliers" }],
      }}
    >
      <Dialog
        BackdropProps={{
          style: {
            // backgroundColor: "transparent",
          },
        }}
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={checkState.show}
        onClose={() => setCheckState({ ...checkState, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText color="secondary" id="alert-dialog-description">
            برای شناسایی ویزیتور شماره موبایل آن را وارد کنید
          </DialogContentText>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              mt: 3,
            }}
          >
            <TextField
              sx={{ input: { textAlign: "center" }, width: "50%" }}
              label="موبایل"
              fullWidth
              value={checkState.mobile ? checkState.mobile : ""}
              onChange={(evt) => {
                setCheckState({ ...checkState, mobile: evt.target.value });
              }}
              size="small"
              variant="outlined"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  if (!checkState.mobile) {
                    enqueueSnackbar("موبایل ویزیتور را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  let state = { visitorMobile: checkState.mobile };
                  updateVisitor(state, () => {
                    setCheckState({ ...checkState, show: false });
                    refresh();
                  });
                }
              }}
            />
            <Button
              variant="contained"
              onClick={() => {
                if (!checkState.mobile) {
                  enqueueSnackbar("موبایل ویزیتور را وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
                let state = { visitorMobile: checkState.mobile };
                updateVisitor(state, () => {
                  setCheckState({ ...checkState, show: false });
                  refresh();
                });
              }}
            >
              ثبت
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      {supplierRes ? (
        <DataGrid
          className="ltr-grid"
          disableVirtualization
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={supplierRes.pageCondition.pageCount}
          rows={supplierRes.items}
          paginationMode="server"
          page={supplierRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={supplierRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              nofab: true,
              isLtr: true,
              rowCount: supplierRes.pageCondition.totalItemCount,
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}

      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"تامین کننده شرکت"}
        callback={() => {
          setProgress(true);
          deleteSupplier(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
